export enum TextAlignement {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
